var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-md text-center" }, [
    _c("form", { staticClass: "form-signin" }, [
      _c(
        "h1",
        { staticClass: "display-4", attrs: { id: "HeaderPleaseLogin" } },
        [_vm._v("Bitte anmelden")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form-group mt-4" }, [
        _vm.isForgotenPw
          ? _c("label", { staticClass: "sr-only" }, [
              _vm._v(
                "Bitte gib die E-Mailadresse an, an die wir den Code zum zurücksetzen\n          des Passworts schicken sollen.\n        "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.isForgotenPw
          ? _c(
              "label",
              { staticClass: "sr-only", attrs: { for: "username" } },
              [_vm._v("E-Mail-Adresse\n        ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.username,
              expression: "username",
            },
          ],
          staticClass: "form-control mt-1",
          class: {
            "is-valid": _vm.emailIsValid,
            "is-invalid": _vm.emailIsInvalid,
          },
          attrs: {
            id: "username",
            placeholder: "meine@email-adresse.de",
            required: "",
            autofocus: "",
          },
          domProps: { value: _vm.username },
          on: {
            change: _vm.validateUsername,
            input: function ($event) {
              if ($event.target.composing) return
              _vm.username = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      !_vm.isForgotenPw
        ? _c("div", { staticClass: "form-group mt-4" }, [
            _c(
              "label",
              { staticClass: "sr-only", attrs: { for: "inputPassword" } },
              [_vm._v("Passwort ")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password",
                },
              ],
              staticClass: "form-control mt-1",
              class: {
                "is-valid": _vm.pwIsValid,
                "is-invalid": _vm.pwIsInValid,
              },
              attrs: {
                id: "password",
                type: "password",
                placeholder: "Password",
                required: "",
              },
              domProps: { value: _vm.password },
              on: {
                change: _vm.validatePW,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.password = $event.target.value
                },
              },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isForgotenPw
        ? _c("div", { staticClass: "form-group m-4" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-lg btn-primary btn-block",
                attrs: { type: "button", id: "loginButton" },
                on: { click: _vm.login },
              },
              [_vm._v("\n          Login\n        ")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isForgotenPw
        ? _c("div", { staticClass: "form-group mt-4" }, [
            _c("p", [
              _c(
                "a",
                {
                  staticClass:
                    "link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      _vm.isForgotenPw = true
                    },
                  },
                },
                [_vm._v("\n            Passwort vergessen\n          ")]
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-group mt-4" }, [
        _vm.isForgotenPw
          ? _c(
              "button",
              {
                staticClass: "btn btn-lg btn-primary btn-block",
                attrs: { type: "button" },
                on: { click: _vm.startForgotPwFlow },
              },
              [_vm._v("\n          Code anfordern\n        ")]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.isCodeSent
        ? _c("div", { staticClass: "form-group mt-4" }, [
            _c("label", { attrs: { for: "pwRecoveryCode" } }, [
              _vm._v("Code eingeben"),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.verificationCode,
                  expression: "verificationCode",
                },
              ],
              staticClass: "form-control text-center mt-2",
              attrs: { id: "pwRecoveryCode" },
              domProps: { value: _vm.verificationCode },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.verificationCode = $event.target.value
                },
              },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-group mt-4" }, [
        _vm.isCodeSent
          ? _c("label", { attrs: { for: "NewPw" } }, [_vm._v("Neues Passwort")])
          : _vm._e(),
        _vm._v(" "),
        _vm.isCodeSent
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newPw,
                  expression: "newPw",
                },
              ],
              staticClass: "form-control text-center mt-2",
              attrs: { id: "newPw", type: "password" },
              domProps: { value: _vm.newPw },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.newPw = $event.target.value
                },
              },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group mt-4" }, [
        _vm.isCodeSent
          ? _c(
              "button",
              {
                staticClass: "btn btn-lg btn-primary btn-block mt-2",
                attrs: { type: "button" },
                on: { click: _vm.setNewPw },
              },
              [_vm._v("\n          Eingabe bestätigen\n        ")]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.isForgotenPw
        ? _c("div", { staticClass: "form-group mt-4" }, [
            _c("p", [
              _c(
                "a",
                {
                  staticClass:
                    "link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover",
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      _vm.isForgotenPw = false
                      _vm.isCodeSent = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            Passwort doch nicht vergessen\n          "
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }